import { StatusBar } from "expo-status-bar";
import { useCallback, useEffect, useState } from "react";
import { StyleSheet, Text, View, I18nManager, Platform } from "react-native";
import Main from "./Main";
import { Provider } from "react-redux";
import store from "./redux/store";
import { NavigationContainer, DefaultTheme } from "@react-navigation/native";
import { getLocales, getCalendars } from "expo-localization";
import axios from "axios";
import getLanguage, { setI18nConfig, setLanguage } from "./functions/Language";
import { useFonts } from "expo-font";
import Cookies from "universal-cookie";
import Splash from "./Splash";
import getToken from "./api/token";
import Toast from "react-native-toast-message";
import { height } from "./imports";
const cookies = new Cookies();

export default function App() {
  //console.log(cookies.get("token"));
  const [wait, setWait] = useState(true);
  const [splashDone, setSplashDone] = useState(false);
  // useEffect(() => {
  //   I18nManager.forceRTL(false);
  //   I18nManager.allowRTL(false);

  // }, []);

  useEffect(() => {
    //setLanguage("persian");
    getLanguage();
  }, []);

  let [fontsLoaded] = useFonts({
    main: require("./assets/fonts/Virgoul.ttf"),
    virgoul: require("./assets/fonts/Virgoul.ttf"),
    vazir: require("./assets/fonts/Vazir.ttf"),
  });

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded || wait) {
      await SplashScreen.hideAsync();
    }
  }, [fontsLoaded, wait]);

  useEffect(() => {
    let rtl = false;
    let lang = "english";
    if (Platform.OS === "web") {
      const language = cookies.get("language");
      //(`language cookie: ${language}`);
      if (
        language === undefined ||
        language === null ||
        language === "english"
      ) {
        rtl = false;
        lang = "english";
      } else {
        rtl = true;
        lang = "persian";
      }
    } else {
      if (I18nManager.isRTL) {
        rtl = true;
        lang = "persian";
      } else {
        rtl = false;
        lang = "english";
      }
    }
    store.dispatch({ type: "SET_RTL", rtl: rtl, language: lang });
    getToken();
    setWait(false);
  }, []);

  if (!fontsLoaded) {
    return null;
  }

  return (
    <Provider store={store}>
      <NavigationContainer
        theme={{
          ...DefaultTheme,
          colors: {
            ...DefaultTheme.colors,
            background: "#fff",
          },
        }}
      >
        <Main />
        {(wait || !splashDone) && <Splash setSplashDone={setSplashDone} />}
        <Toast />
      </NavigationContainer>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
});
